
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46catchall_93mNhLTQ7rSXMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/[...catchall].vue?macro=true";
import { default as _91errorCode_933CC0yvGfVgMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/[errorCode].vue?macro=true";
import { default as aifluento5PYCropZVMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/aifluent.vue?macro=true";
import { default as indexbzJ0sn7rsWMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/auth/org/email/index.vue?macro=true";
import { default as indexWz0yA5V4FfMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/auth/user/email/index.vue?macro=true";
import { default as indexp5l0Pj9MSuMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/auth/user/passwordChange/index.vue?macro=true";
import { default as indexABIotb2oHrMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/auth/user/social/index.vue?macro=true";
import { default as ax_45buildxJC1cCqoGsMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/ax-build.vue?macro=true";
import { default as ax_45grow7m3dvDviz4Meta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/ax-grow.vue?macro=true";
import { default as axpressoRxv1iAIiOqMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/axpresso.vue?macro=true";
import { default as cases3KpGIR7CRPMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/cases.vue?macro=true";
import { default as companypK47rkDqQeMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/company.vue?macro=true";
import { default as _91taskId_93R8c4W51LFTMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/contest/[contestId]/[taskId].vue?macro=true";
import { default as _91contestId_93VXfrcbaTR4Meta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/contest/[contestId].vue?macro=true";
import { default as indexYAN4z7hJ4AMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/contest/index.vue?macro=true";
import { default as index6j4B8PHzWeMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/index.vue?macro=true";
import { default as indexXC9r0uxtZlMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillAssure/create/index.vue?macro=true";
import { default as indexWUvgCi0xTuMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillAssure/manage/[assessmentId]/index.vue?macro=true";
import { default as indexH5Nm2MAzBAMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillAssure/manage/index.vue?macro=true";
import { default as indexEKQ8EFI1uzMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillAssure/take/index.vue?macro=true";
import { default as _91assessmentId_939NUTP0y8x3Meta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/assessment/[assessmentId].vue?macro=true";
import { default as indexQtFPcDMl1zMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/assessment/index.vue?macro=true";
import { default as indexZIo50TScqnMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/candidate/index.vue?macro=true";
import { default as index6ofZViqynTMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/index.vue?macro=true";
import { default as index32ZW7nnypCMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/report/index.vue?macro=true";
import { default as _91assessmentId_93MIpwYnMV26Meta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/report/pdf-export/assessment/[assessmentId].vue?macro=true";
import { default as _91assessmentId_93os8WX0xOEhMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/report/pdf-export/individual/[assessmentId].vue?macro=true";
import { default as indexNQ0qUxCwhNMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/submission/index.vue?macro=true";
import { default as _91learnId_93WJoZkJpR4XMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/skillAdvance/learn/[learnId].vue?macro=true";
import { default as indexexTRFmzVvtMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/skillAdvance/learn/index.vue?macro=true";
import { default as indexhPWWuWrGtHMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/skillAdvance/learn/my/index.vue?macro=true";
import { default as _91practiceId_93vmy2OtygqzMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/skillAdvance/practice/[practiceId].vue?macro=true";
import { default as indexpYiBa60Nx3Meta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/skillAdvance/practice/index.vue?macro=true";
import { default as indexhrznoyySG1Meta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/skillAdvance/practice/my/index.vue?macro=true";
import { default as indexzFQIq4J9MZMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/about/index.vue?macro=true";
import { default as _91blogId_93oMcSooLKHJMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/blog/[blogId].vue?macro=true";
import { default as indexajrTnRHdWZMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/blog/index.vue?macro=true";
import { default as indexDP333V5fDsMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/contact/index.vue?macro=true";
import { default as indexhsNbE2bxx3Meta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/contact/likelion/index.vue?macro=true";
import { default as indexXIpk1CBTQbMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/event/hcmc-sc/index.vue?macro=true";
import { default as _91collabOrgName_93U9opCKq5zZMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/event/launch-event/[collabOrgName].vue?macro=true";
import { default as indexNT5np0Tz4PMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/event/launch-event/index.vue?macro=true";
import { default as _91eventId_93s3nwpc9L7MMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/events/[eventId].vue?macro=true";
import { default as indexjFri8T4zNQMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/events/index.vue?macro=true";
import { default as indexPooUsEjWVkMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/hiring/index.vue?macro=true";
import { default as indexXM8dIP94i8Meta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/news/index.vue?macro=true";
import { default as completeitz6OWx8kHMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/pricing/checkout/complete.vue?macro=true";
import { default as index1gFeHU2Kc4Meta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/pricing/checkout/index.vue?macro=true";
import { default as index2NHsv0yEyJMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/pricing/index.vue?macro=true";
import { default as indexxW2cREiGbAMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/request/demo/index.vue?macro=true";
import { default as indexwxNX96s9HuMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/skillAdvance/index.vue?macro=true";
import { default as index1oF5wAGJSxMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/skillCertify/index.vue?macro=true";
import { default as indexvhptNAEMkpMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/skillMonitor/index.vue?macro=true";
import { default as indexwuDoe3ZlmpMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/index.vue?macro=true";
import { default as _91taskId_930CNAIonQpxMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/[courseId]/[taskId].vue?macro=true";
import { default as _91taskTemplateId_93lcwpG2kzBGMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/levelAssessment/[trackId]/[levelId]/[taskTemplateId].vue?macro=true";
import { default as indexhBGb0MZbmxMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/levelAssessment/[trackId]/[levelId]/index.vue?macro=true";
import { default as _91levelId_930iLd71LM2QMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/levelAssessment/result/[trackId]/[levelId].vue?macro=true";
import { default as _91taskId_93y7jTJhBac4Meta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/proSkillAssure/[assessmentId]/[taskId].vue?macro=true";
import { default as index5Eg7ew9qktMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/proSkillAssure/[assessmentId]/completed/index.vue?macro=true";
import { default as indexLkqlOdbMPkMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/proSkillAssure/[assessmentId]/index.vue?macro=true";
import { default as _91uuid_93xbv2XdEiSiMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/validate/[uuid].vue?macro=true";
import { default as index7QvdtzLN7fMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/policy/index.vue?macro=true";
import { default as index2E2cHIBJqdMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/profile/index.vue?macro=true";
import { default as indexRk04rrAs4YMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/register/info/index.vue?macro=true";
import { default as indexKCe5uQq7cgMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/settings/index.vue?macro=true";
import { default as indexVaDmkv9hmhMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/settings/org/index.vue?macro=true";
import { default as indexp3EkH7PajKMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/sign/index.vue?macro=true";
import { default as skillcampH8KIoDHbPtMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/skillcamp.vue?macro=true";
import { default as skillcertifyan5PVXic32Meta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/skillcertify.vue?macro=true";
import { default as skillfitw39nPb8RCjMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/skillfit.vue?macro=true";
import { default as skillpathmiTrQGGcDUMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/skillpath.vue?macro=true";
import { default as skills7ne3IRaZy4Meta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/skills.vue?macro=true";
import { default as why_45codepressosC70474GhuMeta } from "/home/runner/work/global-main-frontend/global-main-frontend/application/pages/why-codepresso.vue?macro=true";
export default [
  {
    name: "catchall",
    path: "/:catchall(.*)*",
    meta: _91_46_46_46catchall_93mNhLTQ7rSXMeta || {},
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/[...catchall].vue")
  },
  {
    name: "errorCode",
    path: "/:errorCode()",
    meta: _91errorCode_933CC0yvGfVgMeta || {},
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/[errorCode].vue")
  },
  {
    name: "aifluent",
    path: "/aifluent",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/aifluent.vue")
  },
  {
    name: "auth-org-email",
    path: "/auth/org/email",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/auth/org/email/index.vue")
  },
  {
    name: "auth-user-email",
    path: "/auth/user/email",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/auth/user/email/index.vue")
  },
  {
    name: "auth-user-passwordChange",
    path: "/auth/user/passwordChange",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/auth/user/passwordChange/index.vue")
  },
  {
    name: "auth-user-social",
    path: "/auth/user/social",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/auth/user/social/index.vue")
  },
  {
    name: "ax-build",
    path: "/ax-build",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/ax-build.vue")
  },
  {
    name: "ax-grow",
    path: "/ax-grow",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/ax-grow.vue")
  },
  {
    name: "axpresso",
    path: "/axpresso",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/axpresso.vue")
  },
  {
    name: "cases",
    path: "/cases",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/cases.vue")
  },
  {
    name: "company",
    path: "/company",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/company.vue")
  },
  {
    name: "contest-contestId-taskId",
    path: "/contest/:contestId()/:taskId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/contest/[contestId]/[taskId].vue")
  },
  {
    name: "dashboard-contest-contestId",
    path: "/dashboard/contest/:contestId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/contest/[contestId].vue")
  },
  {
    name: "dashboard-contest",
    path: "/dashboard/contest",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/contest/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-proSkillAssure-create",
    path: "/dashboard/proSkillAssure/create",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillAssure/create/index.vue")
  },
  {
    name: "dashboard-proSkillAssure-manage-assessmentId",
    path: "/dashboard/proSkillAssure/manage/:assessmentId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillAssure/manage/[assessmentId]/index.vue")
  },
  {
    name: "dashboard-proSkillAssure-manage",
    path: "/dashboard/proSkillAssure/manage",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillAssure/manage/index.vue")
  },
  {
    name: "dashboard-proSkillAssure-take",
    path: "/dashboard/proSkillAssure/take",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillAssure/take/index.vue")
  },
  {
    name: "dashboard-proSkillManager-assessment-assessmentId",
    path: "/dashboard/proSkillManager/assessment/:assessmentId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/assessment/[assessmentId].vue")
  },
  {
    name: "dashboard-proSkillManager-assessment",
    path: "/dashboard/proSkillManager/assessment",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/assessment/index.vue")
  },
  {
    name: "dashboard-proSkillManager-candidate",
    path: "/dashboard/proSkillManager/candidate",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/candidate/index.vue")
  },
  {
    name: "dashboard-proSkillManager",
    path: "/dashboard/proSkillManager",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/index.vue")
  },
  {
    name: "dashboard-proSkillManager-report",
    path: "/dashboard/proSkillManager/report",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/report/index.vue")
  },
  {
    name: "dashboard-proSkillManager-report-pdf-export-assessment-assessmentId",
    path: "/dashboard/proSkillManager/report/pdf-export/assessment/:assessmentId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/report/pdf-export/assessment/[assessmentId].vue")
  },
  {
    name: "dashboard-proSkillManager-report-pdf-export-individual-assessmentId",
    path: "/dashboard/proSkillManager/report/pdf-export/individual/:assessmentId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/report/pdf-export/individual/[assessmentId].vue")
  },
  {
    name: "dashboard-proSkillManager-submission",
    path: "/dashboard/proSkillManager/submission",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/proSkillManager/submission/index.vue")
  },
  {
    name: "dashboard-skillAdvance-learn-learnId",
    path: "/dashboard/skillAdvance/learn/:learnId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/skillAdvance/learn/[learnId].vue")
  },
  {
    name: "dashboard-skillAdvance-learn",
    path: "/dashboard/skillAdvance/learn",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/skillAdvance/learn/index.vue")
  },
  {
    name: "dashboard-skillAdvance-learn-my",
    path: "/dashboard/skillAdvance/learn/my",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/skillAdvance/learn/my/index.vue")
  },
  {
    name: "dashboard-skillAdvance-practice-practiceId",
    path: "/dashboard/skillAdvance/practice/:practiceId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/skillAdvance/practice/[practiceId].vue")
  },
  {
    name: "dashboard-skillAdvance-practice",
    path: "/dashboard/skillAdvance/practice",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/skillAdvance/practice/index.vue")
  },
  {
    name: "dashboard-skillAdvance-practice-my",
    path: "/dashboard/skillAdvance/practice/my",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/dashboard/skillAdvance/practice/my/index.vue")
  },
  {
    name: "home-about",
    path: "/home/about",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/about/index.vue")
  },
  {
    name: "home-blog-blogId",
    path: "/home/blog/:blogId()",
    meta: _91blogId_93oMcSooLKHJMeta || {},
    alias: ["/en/home/blog/:blogId()","/ja/home/blog/:blogId()","/ko/home/blog/:blogId()","/vi/home/blog/:blogId()"],
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/blog/[blogId].vue")
  },
  {
    name: "home-blog",
    path: "/home/blog",
    meta: indexajrTnRHdWZMeta || {},
    alias: ["/en/home/blog","/ja/home/blog","/ko/home/blog","/vi/home/blog"],
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/blog/index.vue")
  },
  {
    name: "home-contact",
    path: "/home/contact",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/contact/index.vue")
  },
  {
    name: "home-contact-likelion",
    path: "/home/contact/likelion",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/contact/likelion/index.vue")
  },
  {
    name: "home-event-hcmc-sc",
    path: "/home/event/hcmc-sc",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/event/hcmc-sc/index.vue")
  },
  {
    name: "home-event-launch-event-collabOrgName",
    path: "/home/event/launch-event/:collabOrgName()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/event/launch-event/[collabOrgName].vue")
  },
  {
    name: "home-event-launch-event",
    path: "/home/event/launch-event",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/event/launch-event/index.vue")
  },
  {
    name: "home-events-eventId",
    path: "/home/events/:eventId()",
    meta: _91eventId_93s3nwpc9L7MMeta || {},
    alias: ["/en/home/events/:eventId()","/ja/home/events/:eventId()","/ko/home/events/:eventId()","/vi/home/events/:eventId()"],
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/events/[eventId].vue")
  },
  {
    name: "home-events",
    path: "/home/events",
    meta: indexjFri8T4zNQMeta || {},
    alias: ["/en/home/events","/ja/home/events","/ko/home/events","/vi/home/events"],
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/events/index.vue")
  },
  {
    name: "home-hiring",
    path: "/home/hiring",
    meta: indexPooUsEjWVkMeta || {},
    alias: ["/en/home/hiring","/ja/home/hiring","/ko/home/hiring","/vi/home/hiring"],
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/hiring/index.vue")
  },
  {
    name: "home-news",
    path: "/home/news",
    meta: indexXM8dIP94i8Meta || {},
    alias: ["/en/home/news","/ja/home/news","/ko/home/news","/vi/home/news"],
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/news/index.vue")
  },
  {
    name: "home-pricing-checkout-complete",
    path: "/home/pricing/checkout/complete",
    meta: completeitz6OWx8kHMeta || {},
    alias: ["/en/home/pricing/checkout/complete","/ja/home/pricing/checkout/complete","/ko/home/pricing/checkout/complete","/vi/home/pricing/checkout/complete"],
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/pricing/checkout/complete.vue")
  },
  {
    name: "home-pricing-checkout",
    path: "/home/pricing/checkout",
    meta: index1gFeHU2Kc4Meta || {},
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/pricing/checkout/index.vue")
  },
  {
    name: "home-pricing",
    path: "/home/pricing",
    meta: index2NHsv0yEyJMeta || {},
    alias: ["/en/home/pricing","/ja/home/pricing","/ko/home/pricing","/vi/home/pricing"],
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/pricing/index.vue")
  },
  {
    name: "home-request-demo",
    path: "/home/request/demo",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/request/demo/index.vue")
  },
  {
    name: "home-skillAdvance",
    path: "/home/skillAdvance",
    meta: indexwxNX96s9HuMeta || {},
    alias: ["/en/home/skillAdvance","/ja/home/skillAdvance","/ko/home/skillAdvance","/vi/home/skillAdvance"],
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/skillAdvance/index.vue")
  },
  {
    name: "home-skillCertify",
    path: "/home/skillCertify",
    meta: index1oF5wAGJSxMeta || {},
    alias: ["/en/home/skillCertify","/ja/home/skillCertify","/ko/home/skillCertify","/vi/home/skillCertify"],
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/skillCertify/index.vue")
  },
  {
    name: "home-skillMonitor",
    path: "/home/skillMonitor",
    meta: indexvhptNAEMkpMeta || {},
    alias: ["/en/home/skillMonitor","/ja/home/skillMonitor","/ko/home/skillMonitor","/vi/home/skillMonitor"],
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/home/skillMonitor/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexwuDoe3ZlmpMeta || {},
    alias: ["/en","/ja","/ko"],
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/index.vue")
  },
  {
    name: "learning-courseId-taskId",
    path: "/learning/:courseId()/:taskId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/[courseId]/[taskId].vue")
  },
  {
    name: "learning-levelAssessment-trackId-levelId-taskTemplateId",
    path: "/learning/levelAssessment/:trackId()/:levelId()/:taskTemplateId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/levelAssessment/[trackId]/[levelId]/[taskTemplateId].vue")
  },
  {
    name: "learning-levelAssessment-trackId-levelId",
    path: "/learning/levelAssessment/:trackId()/:levelId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/levelAssessment/[trackId]/[levelId]/index.vue")
  },
  {
    name: "learning-levelAssessment-result-trackId-levelId",
    path: "/learning/levelAssessment/result/:trackId()/:levelId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/levelAssessment/result/[trackId]/[levelId].vue")
  },
  {
    name: "learning-proSkillAssure-assessmentId-taskId",
    path: "/learning/proSkillAssure/:assessmentId()/:taskId()",
    meta: _91taskId_93y7jTJhBac4Meta || {},
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/proSkillAssure/[assessmentId]/[taskId].vue")
  },
  {
    name: "learning-proSkillAssure-assessmentId-completed",
    path: "/learning/proSkillAssure/:assessmentId()/completed",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/proSkillAssure/[assessmentId]/completed/index.vue")
  },
  {
    name: "learning-proSkillAssure-assessmentId",
    path: "/learning/proSkillAssure/:assessmentId()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/proSkillAssure/[assessmentId]/index.vue")
  },
  {
    name: "learning-validate-uuid",
    path: "/learning/validate/:uuid()",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/learning/validate/[uuid].vue")
  },
  {
    name: "policy",
    path: "/policy",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/policy/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/profile/index.vue")
  },
  {
    name: "register-info",
    path: "/register/info",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/register/info/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/settings/index.vue")
  },
  {
    name: "settings-org",
    path: "/settings/org",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/settings/org/index.vue")
  },
  {
    name: "sign",
    path: "/sign",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/sign/index.vue")
  },
  {
    name: "skillcamp",
    path: "/skillcamp",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/skillcamp.vue")
  },
  {
    name: "skillcertify",
    path: "/skillcertify",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/skillcertify.vue")
  },
  {
    name: "skillfit",
    path: "/skillfit",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/skillfit.vue")
  },
  {
    name: "skillpath",
    path: "/skillpath",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/skillpath.vue")
  },
  {
    name: "skills",
    path: "/skills",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/skills.vue")
  },
  {
    name: "why-codepresso",
    path: "/why-codepresso",
    component: () => import("/home/runner/work/global-main-frontend/global-main-frontend/application/pages/why-codepresso.vue")
  }
]